import styled from 'styled-components';

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ButtonContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 5px;
`;
